import { CanActivateFn, type UrlTree } from "@angular/router";
import { Observable, of, switchMap } from "rxjs";
import { inject } from "@angular/core";
import { NewProfileFacade } from "@modules/main/components/profile/new-profile/state/new-profile.facade";
import { Web3NavigationService } from "@modules/web3/services/web3.navigation";
import { Web3MigrationRoutes } from "@modules/web3/w3st-migration.module";

export const migrationIntroGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
	const profileFacade = inject(NewProfileFacade);
	const navigation = inject(Web3NavigationService);

	return profileFacade.getProfile$().pipe(
		switchMap((profile) => {
			if (profile.iso === "GB") {
				navigation.gotoWeb3ByUrl(Web3MigrationRoutes.autoMigrationSignup);
				return of(false);
			}
			return of(true);
		})
	);
};
